import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["external-tasks"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      externalTaskList: build.query<
        ExternalTaskListApiResponse,
        ExternalTaskListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/`,
          params: {
            assignee_name: queryArg.assigneeName,
            created_at_after: queryArg.createdAtAfter,
            created_at_before: queryArg.createdAtBefore,
            due_date_after: queryArg.dueDateAfter,
            due_date_before: queryArg.dueDateBefore,
            firm: queryArg.firm,
            has_matched_rule: queryArg.hasMatchedRule,
            is_excluded: queryArg.isExcluded,
            last_activity_after: queryArg.lastActivityAfter,
            last_activity_before: queryArg.lastActivityBefore,
            last_synced_at_after: queryArg.lastSyncedAtAfter,
            last_synced_at_before: queryArg.lastSyncedAtBefore,
            limit: queryArg.limit,
            linked_tasks_max: queryArg.linkedTasksMax,
            linked_tasks_min: queryArg.linkedTasksMin,
            matter: queryArg.matter,
            needs_update: queryArg.needsUpdate,
            offset: queryArg.offset,
            ordering: queryArg.ordering,
            search: queryArg.search,
            sla_status: queryArg.slaStatus,
            source: queryArg.source,
            status: queryArg.status,
          },
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskLinkList: build.query<
        ExternalTaskLinkListApiResponse,
        ExternalTaskLinkListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.externalTaskPk}/links/`,
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskLinkCreate: build.mutation<
        ExternalTaskLinkCreateApiResponse,
        ExternalTaskLinkCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.externalTaskPk}/links/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskLinkDestroy: build.mutation<
        ExternalTaskLinkDestroyApiResponse,
        ExternalTaskLinkDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.externalTaskPk}/links/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskRetrieve: build.query<
        ExternalTaskRetrieveApiResponse,
        ExternalTaskRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/api/external-tasks/${queryArg.id}/` }),
        providesTags: ["external-tasks"],
      }),
      externalTaskDismissAction: build.mutation<
        ExternalTaskDismissActionApiResponse,
        ExternalTaskDismissActionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.id}/actions/${queryArg.actionId}/dismiss/`,
          method: "POST",
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskRetryAction: build.mutation<
        ExternalTaskRetryActionApiResponse,
        ExternalTaskRetryActionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.id}/actions/${queryArg.actionId}/retry/`,
          method: "POST",
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskAddComment: build.mutation<
        ExternalTaskAddCommentApiResponse,
        ExternalTaskAddCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.id}/add-comment/`,
          method: "POST",
          body: queryArg.addCommentPayload,
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskChangeDueDate: build.mutation<
        ExternalTaskChangeDueDateApiResponse,
        ExternalTaskChangeDueDateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.id}/change-due-date/`,
          method: "POST",
          body: queryArg.changeDueDatePayload,
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskChangeStatus: build.mutation<
        ExternalTaskChangeStatusApiResponse,
        ExternalTaskChangeStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.id}/change-status/`,
          method: "POST",
          body: queryArg.changeStatusPayload,
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskSupportedActions: build.query<
        ExternalTaskSupportedActionsApiResponse,
        ExternalTaskSupportedActionsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/${queryArg.id}/supported-actions/`,
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskBulkCreateList: build.query<
        ExternalTaskBulkCreateListApiResponse,
        ExternalTaskBulkCreateListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/bulk-create/`,
          params: {
            initiated_by_id: queryArg.initiatedById,
            status: queryArg.status,
          },
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskBulkCreateStart: build.mutation<
        ExternalTaskBulkCreateStartApiResponse,
        ExternalTaskBulkCreateStartApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/bulk-create/`,
          method: "POST",
          body: queryArg.startExternalTaskBulkCreateRequest,
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskBulkCreateRetrieve: build.query<
        ExternalTaskBulkCreateRetrieveApiResponse,
        ExternalTaskBulkCreateRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/bulk-create/${queryArg.id}/`,
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskBulkCreateDetail: build.query<
        ExternalTaskBulkCreateDetailApiResponse,
        ExternalTaskBulkCreateDetailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/bulk-create/${queryArg.id}/detail/`,
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskBulkLink: build.mutation<
        ExternalTaskBulkLinkApiResponse,
        ExternalTaskBulkLinkApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/bulk-link/`,
          method: "POST",
          body: queryArg.bulkLinkTasksSchema,
        }),
        invalidatesTags: ["external-tasks"],
      }),
      externalTaskByInternalTask: build.query<
        ExternalTaskByInternalTaskApiResponse,
        ExternalTaskByInternalTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/by-internal-task/`,
          params: {
            internal_task_id: queryArg.internalTaskId,
          },
        }),
        providesTags: ["external-tasks"],
      }),
      externalTaskFilterOptions: build.query<
        ExternalTaskFilterOptionsApiResponse,
        ExternalTaskFilterOptionsApiArg
      >({
        query: () => ({ url: `/api/external-tasks/filter-options/` }),
        providesTags: ["external-tasks"],
      }),
      externalTaskLinkByInternalTask: build.mutation<
        ExternalTaskLinkByInternalTaskApiResponse,
        ExternalTaskLinkByInternalTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/api/external-tasks/link-by-internal-task/${queryArg.internalTaskId}/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["external-tasks"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type ExternalTaskListApiResponse =
  /** status 200  */ PaginatedExternalTaskListItemSchemaList;
export type ExternalTaskListApiArg = {
  /** Filter by assignee name (case-insensitive partial match) - supports multiple values with OR logic */
  assigneeName?: string[];
  createdAtAfter?: string;
  createdAtBefore?: string;
  /** Filter by due date after or equal to this date */
  dueDateAfter?: string;
  /** Filter by due date before or equal to this date */
  dueDateBefore?: string;
  /** Filter by firm ID(s) - supports multiple values */
  firm?: string[];
  /** Filter by whether any rule has matched (true/false) */
  hasMatchedRule?: boolean;
  /** Filter by exclusion status (true=excluded only, false=hide excluded) */
  isExcluded?: boolean;
  /** Filter by last activity (external reply) after or equal to this datetime */
  lastActivityAfter?: string;
  /** Filter by last activity (external reply) before or equal to this datetime */
  lastActivityBefore?: string;
  lastSyncedAtAfter?: string;
  lastSyncedAtBefore?: string;
  /** Number of results to return (default 100, max 1000) */
  limit?: number;
  /** Filter by maximum number of linked internal tasks */
  linkedTasksMax?: number;
  /** Filter by minimum number of linked internal tasks */
  linkedTasksMin?: number;
  /** Filter by matter ID(s) - supports multiple values */
  matter?: string[];
  /** Filter by whether any linked tasks need updates */
  needsUpdate?: boolean;
  /** Starting position for results */
  offset?: number;
  /** Order by field (prefix with - for descending). Supported fields: name, due_date, created_at, modified_at, last_synced_at, last_activity, status */
  ordering?: string;
  /** Search in task name and description - supports multiple search terms with OR logic */
  search?: string[];
  /** Filter by SLA status(es): no_sla, on_time, pending, late - supports multiple values with OR logic */
  slaStatus?: string[];
  /** Filter by source(s) (e.g., FILEVINE) - supports multiple values */
  source?: string[];
  /** Filter by status(es) - supports multiple values */
  status?: string[];
};
export type ExternalTaskLinkListApiResponse =
  /** status 200  */ ExternalTaskLinkSchema[];
export type ExternalTaskLinkListApiArg = {
  /** External task ID */
  externalTaskPk: string;
};
export type ExternalTaskLinkCreateApiResponse =
  /** status 201  */ ExternalTaskLinkSchema;
export type ExternalTaskLinkCreateApiArg = {
  /** External task ID */
  externalTaskPk: string;
  body: {
    internal_task_id: string;
  };
};
export type ExternalTaskLinkDestroyApiResponse = /** status 204  */ any;
export type ExternalTaskLinkDestroyApiArg = {
  /** External task ID */
  externalTaskPk: string;
  id: string;
  /** Link ID */
  pk: string;
};
export type ExternalTaskRetrieveApiResponse =
  /** status 200  */ ExternalTaskDetailSchema;
export type ExternalTaskRetrieveApiArg = {
  /** External task ID */
  id: string;
};
export type ExternalTaskDismissActionApiResponse =
  /** status 200  */ ExternalTaskActionSchema;
export type ExternalTaskDismissActionApiArg = {
  /** Action ID to dismiss */
  actionId: string;
  /** External task ID */
  id: string;
};
export type ExternalTaskRetryActionApiResponse =
  /** status 202  */ ExternalTaskActionSchema;
export type ExternalTaskRetryActionApiArg = {
  /** Action ID to retry */
  actionId: string;
  /** External task ID */
  id: string;
};
export type ExternalTaskAddCommentApiResponse =
  /** status 202  */ ExternalTaskActionSchema;
export type ExternalTaskAddCommentApiArg = {
  /** External task ID */
  id: string;
  addCommentPayload: AddCommentPayload;
};
export type ExternalTaskChangeDueDateApiResponse =
  /** status 202  */ ExternalTaskActionSchema;
export type ExternalTaskChangeDueDateApiArg = {
  /** External task ID */
  id: string;
  changeDueDatePayload: ChangeDueDatePayload;
};
export type ExternalTaskChangeStatusApiResponse =
  /** status 202  */ ExternalTaskActionSchema;
export type ExternalTaskChangeStatusApiArg = {
  /** External task ID */
  id: string;
  changeStatusPayload: ChangeStatusPayload;
};
export type ExternalTaskSupportedActionsApiResponse =
  /** status 200  */ SupportedActionsSchema;
export type ExternalTaskSupportedActionsApiArg = {
  /** External task ID */
  id: string;
};
export type ExternalTaskBulkCreateListApiResponse =
  /** status 200  */ ExternalTaskBulkCreateOperationSchema[];
export type ExternalTaskBulkCreateListApiArg = {
  /** Filter by user who initiated the operation */
  initiatedById?: string;
  /** Filter by operation status (PENDING, RUNNING, COMPLETED, FAILED, CANCELLED) */
  status?: string;
};
export type ExternalTaskBulkCreateStartApiResponse =
  /** status 202  */ ExternalTaskBulkCreateOperationSchema;
export type ExternalTaskBulkCreateStartApiArg = {
  startExternalTaskBulkCreateRequest: StartExternalTaskBulkCreateRequest;
};
export type ExternalTaskBulkCreateRetrieveApiResponse =
  /** status 200  */ ExternalTaskBulkCreateOperationSchema;
export type ExternalTaskBulkCreateRetrieveApiArg = {
  /** Operation ID */
  id: string;
};
export type ExternalTaskBulkCreateDetailApiResponse =
  /** status 200  */ ExternalTaskBulkCreateOperationDetailSchema;
export type ExternalTaskBulkCreateDetailApiArg = {
  /** Operation ID */
  id: string;
};
export type ExternalTaskBulkLinkApiResponse =
  /** status 201  */ BulkLinkResultSchema;
export type ExternalTaskBulkLinkApiArg = {
  bulkLinkTasksSchema: BulkLinkTasksSchema;
};
export type ExternalTaskByInternalTaskApiResponse =
  /** status 200  */ ListExternalTaskWithLinkSchema;
export type ExternalTaskByInternalTaskApiArg = {
  /** Internal task ID to find linked external tasks for */
  internalTaskId: string;
};
export type ExternalTaskFilterOptionsApiResponse =
  /** status 200  */ ExternalTaskFilterOptionsSchema;
export type ExternalTaskFilterOptionsApiArg = void;
export type ExternalTaskLinkByInternalTaskApiResponse =
  /** status 201  */ ExternalTaskLinkSchema;
export type ExternalTaskLinkByInternalTaskApiArg = {
  /** Internal task ID to link the external task to */
  internalTaskId: string;
  body: {
    external_task_id: string;
  };
};
export type ExternalIdentitySchema = {
  id: string | string;
  name: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  filevine_user_id: (string | string) | null;
  casepeer_person_id: (string | string) | null;
  clio_user_id: (string | string) | null;
  litify_user_id: (string | string) | null;
  mycase_user_id: (string | string) | null;
  smartadvocate_user_id: (string | string) | null;
  neos_user_id: (string | string) | null;
  last_synced_at: string | null;
  created_at: string;
  modified_at: string;
};
export type ExternalReplySchema = {
  id: string | string;
  task_id: string | string;
  content: string;
  creator: ExternalIdentitySchema;
  creator_id: (string | string) | null;
  filevine_comment_id: (string | string) | null;
  last_synced_at: string | null;
  external_created_at: string | null;
  created_at: string;
  modified_at: string;
  source_action_id?: (string | string) | null;
  source_task_update_id?: (string | string) | null;
};
export type ExternalTaskRuleType = "LINKING" | "EXCLUSION";
export type ExternalTaskRuleStatus = "ENABLED" | "DISABLED";
export type RuleEvaluationStatus = "MATCHED" | "NO_MATCH";
export type SlaStatus = "no_sla" | "on_time" | "late" | "pending";
export type RuleEvaluationSummarySchema = {
  rule_id: string | string;
  rule_name: string;
  rule_type: ExternalTaskRuleType;
  rule_status: ExternalTaskRuleStatus;
  evaluation_status: RuleEvaluationStatus;
  links_created: number;
  match_sla?: string | null;
  evaluated_at: string;
  sla_status?: SlaStatus;
};
export type ExternalTaskListItemSchema = {
  id: string | string;
  name: string;
  description: string | null;
  status: string;
  due_date: string | null;
  source: string;
  matter_id: string | string;
  matter_name: string | null;
  firm_id: string | string;
  firm_name: string;
  creator: ExternalIdentitySchema;
  assignee: ExternalIdentitySchema;
  last_synced_at: string | null;
  external_created_at: string | null;
  needs_update: boolean;
  linked_tasks_count: number;
  latest_activity: ExternalReplySchema;
  rule_evaluations?: RuleEvaluationSummarySchema[];
  is_excluded?: boolean;
  excluded_by_rule_name?: string | null;
  excluded_by_rule_id?: (string | string) | null;
  is_exclusion_pending?: boolean;
  pending_exclusion_rule_name?: string | null;
  pending_exclusion_rule_id?: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type PaginatedExternalTaskListItemSchemaList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ExternalTaskListItemSchema[];
};
export type ExternalTaskLinkSchema = {
  id: string | string;
  external_task_id: string | string;
  internal_task_id: string | string;
  link_source: string;
  linked_by_id: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type ExternalTaskLinkSource = "MANUAL" | "BATCH_IMPORT" | "AUTO_RULE";
export type TaskUpdateType = "comment" | "activity";
export type TaskUpdateVisibility = "Private" | "Public";
export type CustomUserSchema = {
  id: string | string;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  is_firm_admin?: boolean;
  avatar?: string | null;
  signature?: string | null;
};
export type AgentType =
  | "ingest_transcript_task"
  | "provider_finder"
  | "artifact_digest"
  | "treatment_researcher"
  | "treatment_request_automation"
  | "bland_caller"
  | "slack_task_bot"
  | "blob_sorter"
  | "front_app_integration"
  | "task_generator"
  | "coverage_extractor"
  | "intake_converter"
  | "airtable_sync"
  | "system"
  | "backfill_script"
  | "domain_event_update_orchestrator"
  | "loa_detector"
  | "rainmaker"
  | "deliverable_sync"
  | "bpo_agent"
  | "loa_chaser"
  | "external_task_rule_engine"
  | "external_task_bulk_create"
  | "entity_sync"
  | "case_activation";
export type TaskUpdateSchema = {
  id: string | string;
  task_id: string | string;
  update: string;
  update_type: TaskUpdateType;
  visibility: TaskUpdateVisibility;
  user?: CustomUserSchema;
  agent?: AgentType;
  agent_tags?: string[];
  correlation_id?: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type LinkedTaskSchema = {
  id: string | string;
  name: string;
  description: string | null;
  status_name: string;
  due_date: string | null;
  external_cms_update_status: string;
  link_id: string | string;
  link_source: ExternalTaskLinkSource;
  updates: TaskUpdateSchema[];
  created_at: string;
  modified_at: string;
};
export type ExternalTaskActionType =
  | "ADD_COMMENT"
  | "CHANGE_STATUS"
  | "CHANGE_DUE_DATE";
export type ExternalTaskActionStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "FAILED";
export type AddCommentPayload = {
  type?: "ADD_COMMENT";
  comment: string;
  source_task_update_id?: (string | string) | null;
};
export type ChangeDueDatePayload = {
  type?: "CHANGE_DUE_DATE";
  due_date: string;
};
export type ExternalTaskStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "NOT_APPLICABLE";
export type ChangeStatusPayload = {
  type?: "CHANGE_STATUS";
  status: ExternalTaskStatus;
};
export type ExternalTaskActionSchema = {
  id: string | string;
  external_task_id: string | string;
  action_type: ExternalTaskActionType;
  status: ExternalTaskActionStatus;
  payload:
    | ({
        type: "ADD_COMMENT";
      } & AddCommentPayload)
    | ({
        type: "CHANGE_DUE_DATE";
      } & ChangeDueDatePayload)
    | ({
        type: "CHANGE_STATUS";
      } & ChangeStatusPayload);
  workflow_id: string | null;
  error_message: string | null;
  retry_count: number;
  started_at: string | null;
  completed_at: string | null;
  dismissed_at: string | null;
  initiated_by_id: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type ExternalTaskDetailSchema = {
  id: string | string;
  name: string;
  description: string | null;
  status: string;
  due_date: string | null;
  source: string;
  matter_id: string | string;
  matter_name: string | null;
  firm_id: string | string;
  firm_name: string;
  creator: ExternalIdentitySchema;
  assignee: ExternalIdentitySchema;
  last_synced_at: string | null;
  external_created_at: string | null;
  replies: ExternalReplySchema[];
  linked_tasks: LinkedTaskSchema[];
  pending_actions?: ExternalTaskActionSchema[];
  rule_evaluations?: RuleEvaluationSummarySchema[];
  is_excluded?: boolean;
  excluded_by_rule_name?: string | null;
  excluded_by_rule_id?: (string | string) | null;
  is_exclusion_pending?: boolean;
  pending_exclusion_rule_name?: string | null;
  pending_exclusion_rule_id?: (string | string) | null;
  needs_update: boolean;
  external_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type SupportedActionsSchema = {
  external_task_id: string | string;
  source: string;
  supported_action_types: ExternalTaskActionType[];
};
export type AssigneeRole =
  | "managing_paralegal"
  | "case_manager"
  | "police_report_manager"
  | "medical_records_manager"
  | "demands_team"
  | "benefits_specialist"
  | "claims_team"
  | "acknowledgement_team"
  | "treatment_team"
  | "draft_demand_team"
  | "finalize_demand_team"
  | "demand_readiness_team"
  | "liens_team";
export type ExternalTaskBulkCreateConflictMode = "SKIP" | "CREATE_NEW";
export type ExternalTaskBulkCreateOperationStatus =
  | "PENDING"
  | "RUNNING"
  | "COMPLETED"
  | "FAILED"
  | "CANCELLED";
export type ExternalTaskBulkCreateOperationPhase =
  | "VALIDATING"
  | "CREATING_TASKS"
  | "DONE";
export type ExternalTaskBulkCreateOperationSchema = {
  id: string | string;
  task_type_id: string | string;
  task_type_name: string;
  task_group_id: string | string;
  task_group_name: string;
  assignee_role: AssigneeRole;
  conflict_mode: ExternalTaskBulkCreateConflictMode;
  status: ExternalTaskBulkCreateOperationStatus;
  phase: ExternalTaskBulkCreateOperationPhase;
  workflow_id: string | null;
  total_count: number;
  success_count: number;
  skipped_count: number;
  error_count: number;
  error_message: string | null;
  initiated_by_id: (string | string) | null;
  initiated_by_name: string | null;
  created_at: string;
  completed_at: string | null;
  modified_at: string;
};
export type StartExternalTaskBulkCreateRequest = {
  /** List of external task IDs to process */
  external_task_ids: (string | string)[];
  /** Task type for all created internal tasks (group is inferred) */
  task_type_id: string | string;
  /** Optional assignee role - resolved to a user at processing time based on matter context */
  assignee_role?: AssigneeRole;
  /** How to handle external tasks that already have linked internal tasks */
  conflict_mode?: ExternalTaskBulkCreateConflictMode;
};
export type ExternalTaskBulkCreateItemStatus =
  | "PENDING"
  | "SUCCESS"
  | "SKIPPED"
  | "ERROR";
export type ExternalTaskBulkCreateItemSchema = {
  id: string | string;
  external_task_id: string | string;
  external_task_name: string;
  status: ExternalTaskBulkCreateItemStatus;
  internal_task_id?: (string | string) | null;
  external_task_link_id?: (string | string) | null;
  error_message?: string | null;
  skip_reason?: string | null;
  processed_at?: string | null;
  created_at: string;
  modified_at: string;
};
export type ExternalTaskBulkCreateOperationDetailSchema = {
  operation: ExternalTaskBulkCreateOperationSchema;
  items: ExternalTaskBulkCreateItemSchema[];
};
export type BulkLinkResultSchema = {
  links_created: number;
  links: ExternalTaskLinkSchema[];
};
export type BulkLinkTasksSchema = {
  external_task_ids: (string | string)[];
  task_type_ids?: (string | string)[];
  task_group_ids?: (string | string)[];
};
export type ExternalTaskWithLinkSchema = {
  id: string | string;
  name: string;
  description: string | null;
  status: string;
  due_date: string | null;
  source: string;
  link_id: string | string;
  matter_id: string | string;
  matter_name: string | null;
  firm_id: string | string;
  firm_name: string;
  creator: ExternalIdentitySchema;
  assignee: ExternalIdentitySchema;
  last_synced_at: string | null;
  external_created_at: string | null;
  pending_actions: ExternalTaskActionSchema[];
  created_at: string;
  modified_at: string;
};
export type ListExternalTaskWithLinkSchema = ExternalTaskWithLinkSchema[];
export type FilterOptionSchema = {
  id: string;
  name: string;
};
export type ExternalTaskFilterOptionsSchema = {
  firms: FilterOptionSchema[];
  matters: FilterOptionSchema[];
};
export const {
  useExternalTaskListQuery,
  useExternalTaskLinkListQuery,
  useExternalTaskLinkCreateMutation,
  useExternalTaskLinkDestroyMutation,
  useExternalTaskRetrieveQuery,
  useExternalTaskDismissActionMutation,
  useExternalTaskRetryActionMutation,
  useExternalTaskAddCommentMutation,
  useExternalTaskChangeDueDateMutation,
  useExternalTaskChangeStatusMutation,
  useExternalTaskSupportedActionsQuery,
  useExternalTaskBulkCreateListQuery,
  useExternalTaskBulkCreateStartMutation,
  useExternalTaskBulkCreateRetrieveQuery,
  useExternalTaskBulkCreateDetailQuery,
  useExternalTaskBulkLinkMutation,
  useExternalTaskByInternalTaskQuery,
  useExternalTaskFilterOptionsQuery,
  useExternalTaskLinkByInternalTaskMutation,
} = injectedRtkApi;
